import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconFacebookShare = ({
  title = "Facebook share",
  viewBoxWidth = 9,
  viewBoxHeight = 20,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <path
      d="M2 20h4V10h2.6L9 6.6H6V4.8C6 4 6 3.4 7.3 3.4H9V0H6.3C3.1 0 2 1.7 2 4.5v2H0V10h2v10z"
      fill="#4267B2"
      fillRule="evenodd"
    />
  </Svg.Icon>
)

export default IconFacebookShare
